import React from 'react';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import PoweredByTrAingle from './PoweredByTrAingle';
import './Pricing.css';

const PLANS = [
  {
    name: 'Starter',
    price: '$0',
    badge: 'Free',
    desc: 'Validate the workflow with 10 free redactions.',
    points: ['Secure uploads & exports', 'Pattern presets included', 'Basic audit visibility'],
    tone: 'outline',
    cta: 'Start free',
  },
  {
    name: 'Team',
    price: '$39',
    badge: 'Popular',
    desc: 'For growing teams that need history and collaboration.',
    points: ['Audit logging & history', 'Pattern libraries & presets', 'Priority in-app support'],
    tone: 'primary',
    cta: 'Go Team',
  },
  {
    name: 'Enterprise',
    price: 'Let’s talk',
    badge: 'Custom',
    desc: 'SSO, custom retention, DLP review, and dedicated support.',
    points: ['SSO + RBAC', 'Custom retention windows', 'Dedicated CSM & onboarding'],
    tone: 'ghost',
    cta: 'Talk to us',
  },
];

const TRUST = ['Supports SOC 2 readiness controls', 'HIPAA-aligned workflows', 'GDPR-aligned workflows'];

const Pricing = ({ navigateBack }) => (
  <div className="pricing-page">
    <header className="pricing-hero">
      <div>
        <p className="eyebrow">Pricing <PoweredByTrAingle className="pricing-powered-by" /></p>
        <h1>Simple plans with trust built in.</h1>
        <p className="lead">
          Every plan includes retention controls, audit logging, and reviewable controls.
        </p>
        {navigateBack && (
          <button type="button" className="ghost-btn" onClick={navigateBack}>
            <ArrowBackIosNewRoundedIcon fontSize="small" /> Back
          </button>
        )}
      </div>
    </header>

    <section className="pricing-grid">
      {PLANS.map((plan) => (
        <article key={plan.name} className={`price-card ${plan.tone}`}>
          <div className="price-top">
            <span className="pill">{plan.badge}</span>
            <div className="price-tag">{plan.price}</div>
          </div>
          <h3>{plan.name}</h3>
          <p className="price-desc">{plan.desc}</p>
          <ul>
            {plan.points.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
          <button type="button" className="price-cta">{plan.cta}</button>
        </article>
      ))}
    </section>

    <section className="pricing-trust-strip">
      <div className="trust-left">
        <div className="trust-icon"><ShieldOutlinedIcon fontSize="small" /></div>
        <div>
          <p className="trust-kicker">How your data is protected</p>
          <strong>RBAC, audit logging, and retention controls.</strong>
        </div>
      </div>
      <div className="trust-badges">
        {TRUST.map((label) => (
          <span key={label} className="trust-badge">
            <CheckCircleOutlineRoundedIcon fontSize="small" />
            {label}
          </span>
        ))}
      </div>
    </section>

    <section className="transparency-panel">
      <div>
        <p className="eyebrow">Transparency</p>
        <h3>How your data is handled</h3>
        <p>
          Files are retained only as needed for processing and review, with ownership checks and per-user separation,
          audit logs on upload/redact/download, and RBAC with SSO for enterprise. Need details? We’ll share our data handling overview on request.
        </p>
      </div>
      <div className="transparent-list">
        <div><strong>Retention controls</strong><span>Deletion controls + optional custom windows</span></div>
        <div><strong>Transport controls</strong><span>Access-controlled processing</span></div>
        <div><strong>Audit trail</strong><span>Every upload / redact / download</span></div>
        <div><strong>Access control</strong><span>RBAC + SSO (enterprise)</span></div>
      </div>
    </section>
  </div>
);

export default Pricing;
